<script setup lang="ts">
import { RenderPageActions } from '#layers/chrome';
</script>

<template>
	<div
		class="
			relative flex shrink-0 items-center min-block-(--footer-height)
			after:absolute after:inset-x-0 after:bottom-full after:border-bs
		"
	>
		<div class="mx-auto flex w-page items-center justify-end px-page">
			<div class="flex items-center gap-2">
				<RenderPageActions />
			</div>
		</div>
	</div>
</template>
